import { render } from "./BlckProjectProgress.vue?vue&type=template&id=6264d9f9"
import script from "./BlckProjectProgress.vue?vue&type=script&lang=js"
export * from "./BlckProjectProgress.vue?vue&type=script&lang=js"

import exportComponent from "/usr/local/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__